/** Value of the yard switch that shows every yard's jobs. */
export const ALL_YARDS = 'all'

export function otherYardJobNote(jobYardName: string | null, userYardName: string | null): string {
    const owner = jobYardName ? `${jobYardName}'s job` : "Another yard's job"
    const viewer = userYardName ? `${userYardName} dispatch` : 'you'
    return `${owner}, read-only for ${viewer}`
}

export function resolveBoardYard(
    requested: string | null | undefined,
    userYardId: string | null | undefined,
): string | null {
    const yard = requested ?? userYardId ?? ALL_YARDS
    return yard === ALL_YARDS ? null : yard
}
